import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import MultiSelectViewModelType from '@/ViewModels/Controls/MultiSelectViewModel';

export default class MultiSelect extends Control {

    private jQueryControl: JQuery;

    public constructor(private viewModel: MultiSelectViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<select multiple="multiple">');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'multiselect',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            focus: this.viewModel.isFocusable,

            tooltip: this.viewModel.tooltip,

            visible: this.viewModel.isVisible,

            locator: this.viewModel.locator,

            multiSelectOptions: {
                control: self,

                options: this.viewModel.options
            },

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            }),

            value: this.viewModel.values
        });
    }
}

ComponentManager.setControl('MultiSelect', MultiSelect, 'RADPresentation.HTMLClient.DefaultViewExtensions');